import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Trans } from 'react-i18next';

export function CustomFooter({ handleOpenDialog }) {
    return (
        <Box pt={1} pb={1} pl={1} alignContent={'center'} justifyContent={'center'}>
            <Button size="small" variant="text" startIcon={<AddIcon />} onClick={handleOpenDialog}>
            <Trans i18nKey='standortHinzufügen' ns='instituteConfigurationPage'>Standort hinzufügen</Trans>
            </Button>
        </Box>
    );
}